import React, { useEffect } from "react";
import CustomHeading from "../../../constants/CustomHeading";
import CustomDropdown from "../../../constants/CustomDropdown";
import CustomLabel from "../../../constants/CustomLabel";
  import Faculty from "../../../assets/Faculty.svg";
  import { getdepartmentData } from "../../../redux/actions/dataAction";
import { connect } from "react-redux";

const FacultyProfile = (props) => {
  useEffect(() => {
    props.getdepartmentData();
  }, []);

  return (
    <div className="customContainer">
      <CustomHeading title="Faculty Profile" />
      <div className="row">
        <div className="col-md-4">
          <CustomDropdown
            label="Department :"
            data={props?.department?.data?.map((d) => {
              return { value: d.name };
            })} 
            notDefaultOption
            defaultOption={"Select Department"}
          />
        </div>
        <div className="col-md-4">
          <CustomDropdown
            label="User: :"
            data={props?.department?.data?.map((d) => {
              return { value: d.name };
            })}
            notDefaultOption
            defaultOption={"Select User:"}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-4">
          <img
            src={Faculty}
            alt="Faculty"
            style={{
              "top": "363px",
              "left": "483px",
              "width": "200px",
              "height": "150px",
              "background": "0% 0% no-repeat padding-box",
              "opacity": "1",
            }}
          />
        </div>
        <div className="col-md-4">
          <CustomLabel label={"Title:"} labelValue={""}  />
          <CustomLabel label={"First Name:"} labelValue={""}   />
          <CustomLabel label={"Last Name:"} labelValue={""}  />
          <CustomLabel label={"Blood Group:"} labelValue={""}  />
          <CustomLabel label={"Phone No.:"} labelValue={""}  />
        </div>
        <div className="col-md-4">
          <CustomLabel label={"Date of Birth:"} labelValue={""}  />
          <CustomLabel label={"Aadhar No.:"} labelValue={""}  />
          <CustomLabel label={"Address:"} labelValue={""}  />
          <CustomLabel label={"Website:"} labelValue={""}  />
          <CustomLabel label={"Other Details:"} labelValue={""}  />
        </div>
      </div>
    </div>
  );
};
const mapActionWithProps = {
  getdepartmentData,
};

const mapStateWithProps = (state) => ({
  department: state.data.department,
});
export default connect(mapStateWithProps, mapActionWithProps)(FacultyProfile);
